import React from 'react';
import ConversionLink from './ConversionLink';
import './Hero.css';

function Hero() {
  return (
    <section className="hero">
      <div className="container hero-container">
        <div className="hero-content">
          <h1 className="hero-headline">
            Stop Learning Excel.<br />
            Start Getting Results With AI.
          </h1>
          <p className="hero-subheadline">
            A practical course that shows you how to use Mica to complete real Excel tasks using natural language.
            <br /><br />
            No formulas. No VBA. No confusion.
          </p>
          <ul className="hero-bullets">
            <li>
              <svg className="check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              Make AI build real Excel models for you
            </li>
            <li>
              <svg className="check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              Watch every formula and step being created
            </li>
            <li>
              <svg className="check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              Finish real work in minutes
            </li>
          </ul>
          <div className="hero-cta-wrapper">
            <ConversionLink 
              href="https://buy.stripe.com/8x2cN51kR1ORdKQdg85Ne02" 
              className="hero-cta btn btn-primary btn-large"
            >
              Get Instant Access – $10
            </ConversionLink>
            <p className="hero-cta-note">One-time payment. Lifetime access.</p>
          </div>
        </div>
        <div className="hero-visual">
          <img
            src={`${process.env.PUBLIC_URL}/mica-ai-excel-demo.gif`}
            alt="Mica AI Excel Course Demo - Watch AI build Excel formulas in real-time"
            className="hero-demo-gif"
            fetchpriority="high"
          />
        </div>
      </div>
    </section>
  );
}

export default Hero;
